import { Settings } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader } from '@/components/ui/card';
import type { ConfigurationGroup } from '@/types/commercial/proposal-configurations';
import { StepConfigurationProfileTable } from './step-configuration-profile-table';
import { StepConfigurationStatus } from './step-configuration-status';

interface StepConfigurationCardProps {
  group: ConfigurationGroup;
  onConfigure: (groupId: string) => void;
}

export function StepConfigurationCard({ group, onConfigure }: StepConfigurationCardProps) {
  const borderColor = group.status === 'completed' ? 'border-t-green-500' : 'border-t-yellow-500';

  return (
    <Card className={`border-t-4 ${borderColor}`}>
      <CardHeader className="pb-3">
        <div className="flex items-start justify-between gap-6">
          <div className="flex-1 space-y-2.5">
            <h3 className="text-sm font-semibold">{group.label}</h3>
            <div className="flex w-3/5 items-baseline gap-10">
              <div className="space-y-0.5">
                <p className="text-xs font-bold text-muted-foreground">Total de dispositivos</p>
                <p className="text-sm font-semibold tabular-nums">{group.totalDevices}</p>
              </div>
              <div className="space-y-0.5">
                <p className="text-xs font-bold text-muted-foreground">Aguardando configuração</p>
                <p
                  className={`text-sm font-semibold tabular-nums ${group.pendingConfiguration > 0 ? 'text-yellow-600' : ''}`}
                >
                  {group.pendingConfiguration}
                </p>
              </div>
              <div className="space-y-0.5">
                <p className="text-xs font-bold text-muted-foreground">Configurados</p>
                <p
                  className={`text-sm font-semibold tabular-nums ${group.configuredDevices > 0 ? 'text-green-600' : ''}`}
                >
                  {group.configuredDevices}
                </p>
              </div>
            </div>
          </div>
          <div className="flex shrink-0 items-center gap-3 pt-0.5">
            <StepConfigurationStatus status={group.status} />
            <Button
              variant="outline"
              size="sm"
              onClick={() => onConfigure(group.id)}
              className="gap-1.5"
            >
              <Settings className="h-3.5 w-3.5" />
              Configurar
            </Button>
          </div>
        </div>
      </CardHeader>
      <CardContent>
        <StepConfigurationProfileTable profiles={group.selectedProfiles} />
      </CardContent>
    </Card>
  );
}
